import { createI18n } from 'vue-i18n'
import pt from './locales/pt.json'
import en from './locales/en.json'
import fr from './locales/fr.json'
import de from './locales/de.json'
import es from './locales/es.json'
import zh from './locales/zh.json'

// Get language from cookie
function getLanguageFromCookie() {
  if (typeof document === 'undefined') return 'pt'
  
  const cookies = document.cookie.split(';')
  for (let cookie of cookies) {
    const trimmed = cookie.trim()
    if (trimmed.startsWith('smartsurf_language=')) {
      const value = trimmed.substring('smartsurf_language='.length)
      if (['pt', 'en', 'fr', 'de', 'es', 'zh'].includes(value)) {
        return value
      }
    }
  }
  return 'pt'
}



export default createI18n({
  legacy: true,
  locale: getLanguageFromCookie(),
  fallbackLocale: 'pt',
  messages: {
    pt,
    en,
    fr,
    de,
    es,
    zh
  }
})